import { TODO } from '@/interfaces';
import { ERR_MSG, FORMAT_DATE } from '@/interfaces/constants';
import { APP_CONFIG } from '@/utils/env';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { showError } from './alert';
dayjs.extend(utc);
dayjs.extend(timezone);

export const getCookie = (cname: string | undefined) => {
  if (!cname) {
    return;
  }
  const name = cname + '';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length + 1, c.length);
    }
  }
  return '';
};

/**
 * Set cookie
 **/
export const saveCookie = (cookieData: { name: string; value: string; exdays: number }): void => {
  if (!cookieData?.name) {
    return;
  }
  const date = new Date();
  date.setTime(date.getTime() + cookieData.exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${cookieData.name}=${cookieData.value}; expires=${date.toUTCString()}`;
};

/**
 * Del Cookie by name
 **/
export const delCookie = (name: string) => {
  if (!name) {
    return;
  }
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

/**
 * Check Empty data
 **/
export const isEmpty = (value: TODO): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
};

export const validationPhone = (value: string, callback: TODO) => {
  if (/(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/.test(value)) {
    return callback();
  }
  return callback('Số điện thoại chưa đúng định dạng');
};

export const stringToSlug = (str: string): string => {
  // Chuyển hết sang chữ thường
  str = str.toLowerCase();

  // xóa dấu
  str = str
    .normalize('NFD') // chuyển chuỗi sang unicode tổ hợp
    .replace(/[\u0300-\u036f]/g, ''); // xóa các ký tự dấu sau khi tách tổ hợp

  // Thay ký tự đĐ
  str = str.replace(/[đĐ]/g, 'd');

  // Xóa ký tự đặc biệt
  str = str.replace(/([^0-9a-z-\s])/g, '');

  // Xóa khoảng trắng thay bằng ký tự -
  str = str.replace(/(\s+)/g, '-');

  // Xóa ký tự - liên tiếp
  str = str.replace(/-+/g, '-');

  // xóa phần dư - ở đầu & cuối
  str = str.replace(/^-+|-+$/g, '');

  // return
  return str;
};

export const getUrlImage = (url = '') => {
  return url && url !== '' ? APP_CONFIG.apiUrl + url : null;
};

export const getExpirationDate = (jwtToken: string) => {
  if (!jwtToken) {
    return null;
  }

  const jwt = JSON.parse(atob(jwtToken.split('.')[1]));

  // multiply by 1000 to convert seconds into milliseconds
  return (jwt && jwt.exp && jwt.exp * 1000) || null;
};

export const formatNumber = (value: number) => {
  const mum = Number((Math.abs(value) * 100).toPrecision(15));
  const rounded = (Math.round(mum) / 100) * Math.sign(value);
  return rounded.toLocaleString('en-US');
};

export const formatNumberString = (value: string) => {
  if (!value) return 0;
  return formatNumber(Number(value));
}

export const checkImageFile = (data: File[]): boolean => {
  for (const key in data) {
    const file = data[key];
    if (file.type !== 'image/png' && file.type !== 'image/gif' && file.type !== 'image/jpeg') {
      return false;
    }
  }
  return true;
};

export const getBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const handleFilterSelectOptions = (inputValue: string, option: TODO) => {
  return (
    option.value.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0 ||
    option.value.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
  );
};

export const formatDate = (date: string, format = FORMAT_DATE) => {
  return dayjs(date).tz('Asia/Seoul').format(format);
};

export const removeSpace = (str: string) => str.replace(/\s/g, '');

export const handleMsgError = async (errMsg: string, t: (key: string) => string) => {
  switch (errMsg) {
    case ERR_MSG.ERROR_DUPLICATED_BET_LIMIT:
      await showError(t('limit.set_limit_bet_game.duplicated'))
      break;
    case ERR_MSG.ERROR_DUPLICATED_PAYOUT_LIMIT:
      await showError(t('payout_limit.set_limit_payout_game.duplicated'))
      break;
    default:
      await showError(errMsg)
  }
}